import { ConstructionCompanyDetailPage } from '@/features/companies/pages/detail-page/construction-company-detail';

export const ConstructionCompanyDetailRoute = () => {
  return <ConstructionCompanyDetailPage />;
};
